﻿<script setup>
import {ref, computed, inject, defineEmits, watch, useModel, onMounted} from 'vue';
import { useDate } from 'vuetify';
import { vMaska } from "maska/vue"
import rules from "@/utils/validationRules.js";

const dayjs = inject('dayJS');

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
  rules: {
    type: Array,
    default: () => []
  },
})

const date = useDate();

const dateModel = defineModel();

const isPickerOpen = ref(false)
const formattedModelDate = ref('');

const rulesToUse = computed(() => [
  ...(props.required
      ? [rules.required, v => dayjs(v, 'DD/MM/YYYY', true).isValid() || 'Date format must be dd/mm/yyyy']
      : []),
  ...props.rules
]);
function formatDate() {
  if (!dateModel.value) return ''
  return date.format(dateModel.value, 'keyboardDate')
}

function handleDateInput(event) {
  if (formattedModelDate.value.length === 10) {
    if (dayjs(formattedModelDate.value, 'DD/MM/YYYY', true).isValid()) {
      dateModel.value = dayjs(formattedModelDate.value, 'DD/MM/YYYY').toDate();
    }
  }
  
  if ([2,5].includes(formattedModelDate.value.length) && event.inputType === 'insertText') {
    formattedModelDate.value += '/'
  }
}

watch(dateModel, () => {
  if (dateModel.value) {
    formattedModelDate.value = formatDate();
  } else {
    formattedModelDate.value = '';
  }
})

onMounted(() => {
  if (dateModel.value) {
    formattedModelDate.value = formatDate();
  }
})

</script>

<template>
  <v-text-field
  v-model="formattedModelDate"
  :active="isPickerOpen"
  prepend-inner-icon="mdi-calendar"
  placeholder="dd/mm/yyyy"
  v-maska="'##/##/####'"
  inputmode="numeric"
  @input="handleDateInput"
  :required="required"
  :rules="rulesToUse">
  <v-menu
      v-model="isPickerOpen"
      :close-on-content-click="false"
      activator="parent"
      transition="scale-transition">
    <v-date-picker
        v-if="isPickerOpen"
        v-model="dateModel"
        hide-header
        full-width
        color="primary">
      <template #actions>
        <slot name="actions"></slot>
      </template>
    </v-date-picker>
  </v-menu>
  </v-text-field>
</template>
